var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',[_c('h1',{staticClass:"mb-4"},[_c('v-icon',{attrs:{"large":""}},[_vm._v("location_on")]),_vm._v(" Puntos de venta")],1),_c('img',{attrs:{"src":require("@/assets/images/puntosdeventa.jpeg"),"alt":"Puntos de venta TicketShop"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }